import { connect } from 'react-redux';
import { deleteTier } from '../../redux/creator/actions';
var mapDispatchToProps = function (dispatch, _a) {
    var deviation = _a.deviation;
    return ({
        deleteTier: function () { return dispatch(deleteTier(deviation)); },
    });
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=DeleteTier.container.js.map